'use strict';

require('./roboto-fontface.css');

require('./frontend');


//////////////////
// WEBPACK FOOTER
// ./program/entry.js
// module id = 332
// module chunks = 0